import axios from 'axios'

import adapter from './adapter'

export const getProductsAds = async props => {
  const {
    context,
    device,
    position,
    sessionId,
    userId,
    productId,
    categoryName,
    term
  } = props

  const baseHost = window.env.newTail.baseHost
  const publisherId = window.env.newTail.publisherId
  const endpoint = `${baseHost}rma/${publisherId}`
  const mediaType = 'product'

  const payload = {
    context,
    product_sku: productId && String(productId),
    category_name: categoryName,
    term,
    session_id: sessionId,
    user_id: userId,
    placements: {
      [`${device}_${context}_${position}_${mediaType}`]: {
        quantity: 10,
        types: ['product']
      }
    }
  }

  const response = await axios.post(endpoint, payload)

  return adapter({
    context,
    position,
    device,
    mediaType,
    externalResponse: response
  })
}

export const getBannersAds = async props => {
  const {
    context,
    position,
    device,
    sessionId,
    userId,
    productId,
    categoryName,
    size,
    term
  } = props

  const baseHost = window.env.newTail.baseHost
  const publisherId = window.env.newTail.publisherId
  const endpoint = `${baseHost}rma/${publisherId}`
  const mediaType = 'banner'

  const payload = {
    context,
    position,
    product_sku: String(productId),
    category_name: categoryName,
    term,
    session_id: sessionId,
    user_id: userId,
    placements: {
      [`${device}_${context}_${position}_${mediaType}`]: {
        quantity: 1,
        types: ['banner'],
        size
      }
    }
  }

  const response = await axios.post(endpoint, payload)

  return adapter({
    context,
    position,
    device,
    mediaType,
    externalResponse: response
  })
}
